/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from 'react';
import { ExcelExperiment } from '../../experiments/TrialConversion/ExcelExperiment';

export const ExcelView = () => {
    return <ExcelExperiment />;
};

export default ExcelView;
